import { createBusinessLogger } from '@/utils/logger/businessLogger';

// 订单 事件名称常量
export const ORDER_EVENT_NAMES = {
  ORDER_LIST_PAGE_LOAD_FAIL: 'order_list_page_load_fail', // 订单列表异常
  ORDER_DETAIL_PAGE_LOAD_FAIL: 'order_detail_page_load_fail', // 订单详情异常
} as const;

// 导出类型定义，既可以当常量用也可以当类型用
export type OrderEventNames = typeof ORDER_EVENT_NAMES;

// 暂时不需要分类，之后有需要再添加
const categoryNames: string[] = [];

// Business Logger 实例 - 订单
export const orderBusinessLogger = createBusinessLogger<OrderEventNames>('order', categoryNames);
